import React, { Children } from 'react'

export default function Modal({open, onClose}){
    if (!open) return null
    return(
        <button onClick={onClose} className="ModalCloseButton">
            <img src = {require('./WORKMARK.png')}></img>
            <h2>The aim is to guess which of the two capital cities is warmer at this exact time.</h2>
            <h2>Each round presents you with the weather report of two random capital cities, with some information hidden.</h2>
            <h2>Clicking on the "Hint?" button will uncover the next line of the weather report, at a cost to the potential score.</h2>
            <h2>Try to keep up your streak, as it will help you get a higher score!</h2>
            <br/>
            <h2>Created by <a href='https://liamkenna.com.au' target="_blank">Liam Kenna</a> in an attempt to learn React.</h2>
            <h3>Click anywhere to close</h3>
        </button>
    )
}